export default "__VITE_ASSET__DzUCMlH6__"